import axios from "@/app/plugins/Axios";


export default {

  registrarTerminal() {
    return axios.post("/sistema/terminal-register").then((response) => response.data);
  },

  loadTerminalConfig() {
    return axios.get(`/sistema/terminal-config`).then((response) => response.data);
  },

  updateTerminalConfig(config) {
    return axios.put(`/sistema/terminal-config`, config).then((response) => response.data);
  }

}

